import { makeCrudStateReducer } from "seneca-common/utils/apiStates";

import { courseEnrollmentsCrudConfig } from "../consts";

const courseEnrollmentsCrudStateReducer = makeCrudStateReducer(
  courseEnrollmentsCrudConfig
);

export default courseEnrollmentsCrudStateReducer;
